import type { CSSProperties } from 'react'

// Shared styling for widgets that render INSIDE the CopilotKit chat bubble
// (ChoicePrompt, RenderCard, …).
//
// CopilotKit's chat-message CSS overrides Mantine's class-based styles inside
// the bubble (fonts reset to ui-sans-serif, and class-based padding/border
// collapse to 0). So chat widgets are styled with explicit INLINE styles built
// from the app's Mantine CSS variables — inline styles win over the chat's
// stylesheet, so the widget stays on-brand and correctly themed (incl. dark
// mode) wherever it renders.
export const FONT = 'var(--mantine-font-family)'
export const BRAND = 'var(--mantine-primary-color-filled)'
export const BRAND_LIGHT = 'var(--mantine-primary-color-light)'
export const BRAND_HOVER = 'var(--mantine-primary-color-filled-hover)'
export const BORDER = 'var(--mantine-color-default-border)'
export const SURFACE = 'var(--mantine-color-default)'
export const TEXT = 'var(--mantine-color-text)'
export const DIMMED = 'var(--mantine-color-dimmed)'
export const ON_PRIMARY = 'var(--ad-on-primary, #fff)'

// The widget's outer container. Because the chat resets Mantine's class-based
// Card padding/border to 0 (and clips with overflow:hidden, which crops a
// flush-mounted title), we build the card chrome from DIRECT inline styles —
// which beat the chat stylesheet — instead of a Mantine <Card>.
export const cardStyle: CSSProperties = {
    fontFamily: FONT,
    maxWidth: 600,
    margin: 'var(--mantine-spacing-xs) 0',
    padding: 'var(--mantine-spacing-lg)',
    border: `1px solid ${BORDER}`,
    borderRadius: 'var(--mantine-radius-md)',
    background: SURFACE,
    boxShadow: 'var(--mantine-shadow-xs)',
}
